import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest, debounceTime, filter, Observable } from 'rxjs';
import {
  CommissionReportSalesPersonCommissionsDashboardModel,
  CommissionReportSalesPersonCommissionsDashboardAmountModel,
} from '../../../../../../shared/store/commissions/commission/types';
import { SmartAction, View } from '../../../../../../shared/store/view/types';
import { SearchService } from '../../../../../../shared/store/search/search.service';
import { ViewService } from '../../../../../../shared/store/view/views.service';
import { CommissionService } from '../../../../../../shared/store/commissions/commission/commission.service';
import { Filter } from '../../../../../../shared/store/search/types';
import { Router } from '@angular/router';

@UntilDestroy()
@Component({
  selector: 'app-sales-person-commissions-dashboard',
  standalone: false,
  templateUrl: './sales-person-commissions-dashboard.component.html',
  styleUrl: './sales-person-commissions-dashboard.component.scss',
})
export class SalesPersonCommissionsDashboardComponent
  implements OnInit, OnDestroy
{
  data$: Observable<CommissionReportSalesPersonCommissionsDashboardModel>;
  view$: Observable<View>;

  smartAction: SmartAction;

  constructor(
    private readonly searchService: SearchService,
    private readonly viewService: ViewService,
    private readonly commissionService: CommissionService,
    private readonly router: Router,
  ) {
    this.view$ = this.viewService.getViews.value$;
    this.data$ =
      this.commissionService.getSalesPersonCommissionsDashboardData.value$;
  }

  ngOnInit(): void {
    combineLatest([this.view$, this.searchService.getActiveFilters()])
      .pipe(
        filter(([view, activeFilter]) => !!view && !!activeFilter),
        debounceTime(200),
        untilDestroyed(this),
      )
      .subscribe(([view, activeFilters]) => {
        // this.commissionService.getSalesPersonCommissionsDashboardData.reset();
        this.commissionService.getSalesPersonCommissionsDashboardData.call(
          activeFilters,
        );
      });

    this.smartAction = {
      id: 'commissionsPreview',
      label: 'CommissionsPreview',
      url: '/Finance/SalesPersonCommissions/Previews/List',
      count: 0,
      filter: <Filter>{},
      icon: '',
      actif: true,
      singleId: '',
    };
  }

  ngOnDestroy(): void {
    this.commissionService.getSalesPersonCommissionsDashboardData.reset();
  }

  onSmartLinkClick(smartAction: SmartAction, filters: Filter[]): void {
    this.searchService.temporaryKeepActiveFilters(
      this.router.url,
      smartAction.url,
    );

    if (filters.length > 0) {
      for (let i = 0; i < filters.length; i++) {
        this.searchService.addActiveFilter(filters[i], true);
      }
    }

    this.searchService.resetActiveFilter();

    this.router.navigate([smartAction.url], {
      state: { useTempFilter: true },
    });
  }
}
